var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("color-picker", {
        attrs: { theme: "light", color: _vm.color, "colors-default": [] },
        on: { changeColor: _vm.changeColor }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }